/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateInventoryRecordDto } from '../models/CreateInventoryRecordDto';
import type { CreateInventoryRecordWithItemsDto } from '../models/CreateInventoryRecordWithItemsDto';
import type { InventoryRecordDetailedResponseDto } from '../models/InventoryRecordDetailedResponseDto';
import type { InventoryRecordLabelPrintResponseDto } from '../models/InventoryRecordLabelPrintResponseDto';
import type { InventoryRecordListResponseDto } from '../models/InventoryRecordListResponseDto';
import type { UpdateInventoryRecordDto } from '../models/UpdateInventoryRecordDto';
import type { UpdateInventoryRecordWithItemsDto } from '../models/UpdateInventoryRecordWithItemsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InventoryRecordsService {
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordsControllerCreate(
    requestBody: CreateInventoryRecordDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/inventory-records',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all inventory records with total items count
   * @param page Page number
   * @param limit Items per page
   * @param recordCode Filter by record code
   * @param status Filter by status
   * @param destinationLocationId Filter by destination location ID
   * @param startDate Start date for filtering records (ISO format)
   * @param endDate End date for filtering records (ISO format)
   * @param searchTerm Search term for full-text search across record code, product names, and codes
   * @param createdInLastHours Filter records created in the last X hours
   * @param supplierId Filter by record-level supplier ID
   * @param sortBy Sort field
   * @param sortOrder Sort order
   * @returns InventoryRecordListResponseDto Inventory records retrieved successfully with total items count for each record
   * @throws ApiError
   */
  public static inventoryRecordsControllerFindAll(
    page: number = 1,
    limit: number = 10,
    recordCode?: string,
    status?: 'COMPLETED' | 'CANCELLED' | 'PENDING',
    destinationLocationId?: number,
    startDate?: string,
    endDate?: string,
    searchTerm?: string,
    createdInLastHours?: number,
    supplierId?: number,
    sortBy?: 'createdAt' | 'recordCompletedAt' | 'recordCode',
    sortOrder?: 'ASC' | 'DESC',
  ): CancelablePromise<InventoryRecordListResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-records',
      query: {
        page: page,
        limit: limit,
        recordCode: recordCode,
        status: status,
        destinationLocationId: destinationLocationId,
        startDate: startDate,
        endDate: endDate,
        searchTerm: searchTerm,
        createdInLastHours: createdInLastHours,
        supplierId: supplierId,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    });
  }
  /**
   * Export all inventory records matching the applied filters to CSV
   * @param recordCode Filter by record code
   * @param status Filter by status
   * @param destinationLocationId Filter by destination location ID
   * @param startDate Start date for filtering records (ISO format)
   * @param endDate End date for filtering records (ISO format)
   * @param searchTerm Search term for full-text search across record code, product names, and codes
   * @param createdInLastHours Filter records created in the last X hours
   * @param supplierId Filter by record-level supplier ID
   * @returns binary CSV file
   * @throws ApiError
   */
  public static inventoryRecordsControllerExportToCsv(
    recordCode?: string,
    status?: 'COMPLETED' | 'CANCELLED' | 'PENDING',
    destinationLocationId?: number,
    startDate?: string,
    endDate?: string,
    searchTerm?: string,
    createdInLastHours?: number,
    supplierId?: number,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-records/export/csv',
      query: {
        recordCode: recordCode,
        status: status,
        destinationLocationId: destinationLocationId,
        startDate: startDate,
        endDate: endDate,
        searchTerm: searchTerm,
        createdInLastHours: createdInLastHours,
        supplierId: supplierId,
      },
      errors: {
        400: `Too many matching rows to export`,
      },
    });
  }
  /**
   * Get inventory records status summary metrics
   * @param locationId Optional location filter by destination location
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordsControllerGetRecordSummary(
    locationId?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-records/metrics/summary',
      query: {
        locationId: locationId,
      },
    });
  }
  /**
   * Get an inventory record by ID with total items count
   * @param id
   * @returns any Inventory record retrieved successfully with total items count
   * @throws ApiError
   */
  public static inventoryRecordsControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-records/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordsControllerUpdate(
    id: string,
    requestBody: UpdateInventoryRecordDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/inventory-records/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete an inventory record
   * Deletes an inventory record if it is safe to do so (no associated warehouse products are assigned, sold, or reserved). Requires admin role.
   * @param id
   * @returns any Inventory record deleted successfully
   * @throws ApiError
   */
  public static inventoryRecordsControllerRemove(id: string): CancelablePromise<{
    message?: string;
    deletedRecordId?: number;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/inventory-records/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Cannot delete inventory record because it has associated warehouse products that are assigned, sold, reserved, or in use`,
        404: `Inventory record not found`,
      },
    });
  }
  /**
   * Get a detailed inventory record by ID with all items and product information
   * @param id
   * @param includeWarehouseProducts Include warehouse products in the response (default: false). Can be slow for records with many products.
   * @returns InventoryRecordDetailedResponseDto Detailed inventory record retrieved successfully with items and product information
   * @throws ApiError
   */
  public static inventoryRecordsControllerFindOneDetailed(
    id: string,
    includeWarehouseProducts?: boolean,
  ): CancelablePromise<InventoryRecordDetailedResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-records/{id}/detailed',
      path: {
        id: id,
      },
      query: {
        includeWarehouseProducts: includeWarehouseProducts,
      },
    });
  }
  /**
   * Get warehouse products for a specific inventory record
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordsControllerFindWarehouseProducts(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-records/{id}/warehouse-products',
      path: {
        id: id,
      },
    });
  }
  /**
   * Get minimal fields for printing product labels (barcode = productCodeUnique)
   * @param id
   * @returns InventoryRecordLabelPrintResponseDto Label rows for warehouse units linked to this record
   * @throws ApiError
   */
  public static inventoryRecordsControllerFindLabelPrintItems(
    id: number,
  ): CancelablePromise<InventoryRecordLabelPrintResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-records/{id}/label-print-items',
      path: {
        id: id,
      },
    });
  }
  /**
   * Create an inventory record with items in a single transaction
   * Creates a new inventory record with associated items. Note: If registeredById is provided in the request body, it will be ignored. The authenticated user's ID from the JWT token will be used instead.
   * @param requestBody
   * @returns InventoryRecordDetailedResponseDto Inventory record with items created successfully
   * @throws ApiError
   */
  public static inventoryRecordsControllerCreateWithItems(
    requestBody: CreateInventoryRecordWithItemsDto,
  ): CancelablePromise<InventoryRecordDetailedResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/inventory-records/with-items',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update an inventory record with items in a single transaction
   * @param id
   * @param requestBody
   * @returns InventoryRecordDetailedResponseDto Inventory record with items updated successfully
   * @throws ApiError
   */
  public static inventoryRecordsControllerUpdateWithItems(
    id: string,
    requestBody: UpdateInventoryRecordWithItemsDto,
  ): CancelablePromise<InventoryRecordDetailedResponseDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/inventory-records/{id}/with-items',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Cancel an inventory record
   * Cancels an inventory record and marks all associated warehouse products as cancelled. This preserves the record for audit purposes instead of deleting it.
   * @param id
   * @returns any Inventory record cancelled successfully
   * @throws ApiError
   */
  public static inventoryRecordsControllerCancelRecord(id: string): CancelablePromise<{
    message?: string;
    cancelledRecordId?: number;
    cancelledProductsCount?: number;
  }> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/inventory-records/{id}/cancel',
      path: {
        id: id,
      },
      errors: {
        400: `Cannot cancel inventory record because it has products that are already assigned, sold, reserved, or in use`,
        404: `Inventory record not found`,
      },
    });
  }
}
